import * as React from "react"

function Arrow(props) {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M19.9998 25.3346L18.0998 23.468L24.2332 17.3346H2.6665V14.668H24.2332L18.1332 8.53464L19.9998 6.66797L29.3332 16.0013L19.9998 25.3346Z" fill="#D7DEE6" />
    </svg>
  )
}

export default Arrow
